import React from 'react';
import { Search } from 'lucide-react';
import ContractListItem from './ContractListItem';

interface SearchResultsListProps {
    loading: boolean;
    resultsCount: number;
    displayedResults: any[];
    savedIds: Set<string>;
    handleToggleSave: (opp: any, e?: React.MouseEvent) => void;
    setSelectedContract: (opp: any) => void;
    selectedContractor: string;
}

export default function SearchResultsList({
    loading,
    resultsCount,
    displayedResults,
    savedIds,
    handleToggleSave,
    setSelectedContract,
    selectedContractor
}: SearchResultsListProps) {
    return (
        <div className="xl:col-span-9 space-y-4">
            {/* Feed Header */}
            <div className="flex items-center justify-between px-1">
                <h2 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">Live & Actionable</h2>
                <div className="text-xs text-gray-600 font-mono">
                    Showing {displayedResults.length} / {resultsCount} Scanned
                </div>
            </div>

            {/* High Density Table Header */}
            <div className="hidden md:grid grid-cols-12 gap-4 px-4 py-2 text-[10px] font-bold text-gray-600 uppercase tracking-widest border-b border-white/5">
                <div className="col-span-1 text-center">Fit Score</div>
                <div className="col-span-6">Opportunity</div>
                <div className="col-span-2">Deadline</div>
                <div className="col-span-3 text-right">Actions</div>
            </div>

            {/* Feed List */}
            <div className="space-y-2">
                {loading && displayedResults.length === 0 ? (
                    // Skeleton
                    [1, 2, 3, 4, 5].map(i => (
                        <div key={i} className="h-16 bg-[#0A0A0A] border border-white/5 rounded animate-pulse" />
                    ))
                ) : displayedResults.length === 0 ? (
                    <div className="text-center py-20 opacity-50">
                        <Search className="w-12 h-12 text-gray-700 mx-auto mb-4" />
                        <h3 className="text-lg text-gray-500">No opportunities found</h3>
                        <p className="text-sm text-gray-700">Try adjusting your filters or "Show All"</p>
                    </div>
                ) : (
                    displayedResults.map((opp) => (
                        <ContractListItem
                            key={opp.noticeId}
                            opp={opp}
                            isSaved={savedIds.has(opp.noticeId)}
                            onToggleSave={handleToggleSave}
                            onSelect={setSelectedContract}
                            selectedContractor={selectedContractor}
                        />
                    ))
                )}
            </div>
        </div>
    );
}
